import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { CustomInput, CustomPassword } from "shared/components/allInput";
import CustomButton from "shared/components/inputButton";
import { useDispatch } from "react-redux";
import { LoginAction } from "store/actions/AuthActions";
import { useState } from "react";
import formValidation from "utils/validations";
import { showFormErrors } from "utils/CommonFunctions";

export default function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    email: "",
    password: "",
  })
  const onSubmit = async () => {
    if (showFormErrors(data, setData)) {
      dispatch(LoginAction(data, dispatch, setLoading, navigate))
    }
  };

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data)
    setData((prev) => ({ ...prev, [name]: value, formErrors }))
  }

  return (
    <>
      <h2 className={`text-2xl md:text-4xl text-left py-1 mb-2`}>
        {'Welcome to'}
        <span className="color-sycamore"> {"athena-io."}</span>
      </h2>
      <p className="text-lg text-left">{"Please sign in to view and manage your contracts and to access our services."}</p>
      <div className="mt-5 pt-2" >
        <CustomInput name="email" data={data} onChange={handleChange} col={12} />
        <CustomPassword name="password" data={data} onChange={handleChange} feedback={false}/>
        <CustomButton
          extraClassName="mt-5 mb-4 w-full"
          label="Log In"
          loading={loading}
          onClick={onSubmit}
        />
        <Link
          to="/forgot-password"
          className="block mb-4 m-3 pt-1 pb-2 color-grey underline text-center"
        >
          Forgot Password?
        </Link>
        <p className="text-center">
          Don’t have an account?{" "}
          <Link to="/sign-up" className="underline color-black">
            Sign Up
          </Link>
        </p>
        <div className="h-2rem"></div>
      </div>
    </>
  );
}
